import React, { useState } from "react";
import { TableRow, TableCell, IconButton } from "@mui/material";
// import dele from "../../../../assets/DigitalMarketing/image/delete.svg";
import eye from "../../../../assets/DigitalMarketing/image/visibility.svg";
import docs from "../../../../assets/DigitalMarketing/image/docs.svg";
import { styled } from "@mui/material/styles";
// import { IoDocumentTextOutline } from "react-icons/io5";
import TestOrderPopup from "./TestOrderPopup";
import { useGetTestOrderDetailsbyIdQuery } from "../../../../Service/LabManagement";
// import { useParams } from "react-router-dom";

// Define custom types for priority and status props
interface PriorityProps {
  priority: "Routine" | "Urgent";
}

interface StatusProps {
  status: "Pending" | "Completed";
}

const PriorityLabel = styled("span")<{ priority: string }>(({ priority }) => ({
  padding: "5px 10px",
  borderRadius: "10px",
  fontSize: "0.75rem",
  color:
    priority === "Urgent"
      ? "#E2005C"
      : priority === "Routine"
      ? "#007FFF"
      : "#FF3D57",
  backgroundColor:
    priority === "Urgent"
      ? "#E2005C"
      : priority === "Routine"
      ? "#E0F7FF"
      : "#FFE7E9",
  fontWeight: 500,
}));

const StatusLabel = styled("span")<StatusProps>(({ status }) => ({
  padding: "5px 10px",
  borderRadius: "10px",
  fontSize: "0.75rem",
  color: status === "Completed" ? "#28A745" : "#6C757D",
  backgroundColor: status === "Completed" ? "#E6F4EA" : "#F1F3F4",
}));

const TableLists = ({ order, setShow, setUpdateData, setView, list, type }) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [Id, setId] = useState();

  const {
    data: TestOrderData,
    isLoading,
    refetch,
  } = useGetTestOrderDetailsbyIdQuery(Id, {
    refetchOnMountOrArgChange: true,
  });

  const handleDocumentClick = (data) => {
    setSelectedData(data);
    setOpenPopup(true);
    setId(data.id);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  console.log(TestOrderData);
  const handleView = (data: any) => {
    setView(true);
    setShow(true);
    setUpdateData(data);
  };
  return (
    <>
      {list?.data?.map((row, index) => (
        <TableRow key={index}>
          <TableCell align="left">{index + 1}</TableCell>
          <TableCell align="left">{row.patientName}</TableCell>
          <TableCell align="left">{row.orderNumber}</TableCell>
          <TableCell align="left">{row.testName}</TableCell>
          <TableCell align="left">{row.labName}</TableCell>
          <TableCell align="left">{row.createdAt}</TableCell>
          <TableCell align="left">
            {row.priorityLevel === "urgent" ? (
              <span className="urgent rounded-pill p-1 ms-2">
                {row.priorityLevel}
              </span>
            ) : (
              <span className="routine rounded-pill p-1 ms-2">
                {row.priorityLevel}
              </span>
            )}
          </TableCell>
          <TableCell align="left">
            <StatusLabel status={row.status as StatusProps["status"]}>
              {row.status}
            </StatusLabel>
          </TableCell>
          <TableCell align="left">
            {/* <IconButton>
              <img
                src={eye}
                alt="view"
                className="blue-c action-icon cursor"
                onClick={() => handleView(row)}
              />
            </IconButton> */}
            <img
              src={docs}
              alt="view"
              className="delete-icon cursor action-icon ms-2"
              onClick={() => handleDocumentClick(row)}
              style={{ marginLeft: "20px" }}
            />
            {/* <img
              src={dele}
              alt="delete"
              className="delete-icon cursor action-icon"
            /> */}
          </TableCell>
        </TableRow>
      ))}
      {selectedData && (
        <TestOrderPopup
          open={openPopup}
          onClose={handleClosePopup}
          // data={selectedData}
          data={TestOrderData}
        />
      )}
    </>
  );
};

export default TableLists;
